// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"6f908421","171":"86b27080","444":"aba583ff","453":"ae7e94b8","507":"ba41d260","968":"197e6bc7"}[chunkId] + ".chunk.js";
};